import React, { useEffect, useState } from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { errMsg } from '@/services/staffAttendanceApi';
import { ewbApi } from '@/services/ewayBillApi';

/** Admin: old bills still waiting for the Tally link (Tally isn't used now) — delete them so the documents can get new e-way bills. */
export const TallyWaitingCard = ({ tick, onDeleted }) => {
  const [r, setR] = useState(null);
  const [sure, setSure] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { ewbApi.tallyWaiting().then(setR).catch(() => setR(null)); }, [tick]);
  if (!r?.count) return null;
  const del = () => {
    setBusy(true);
    ewbApi.deleteTallyWaiting().then((x) => { toast.success(`${x.deleted} bill(s) waiting for Tally deleted`); setR({ count: 0, bills: [] }); setSure(false); onDeleted(); })
      .catch((e) => toast.error(errMsg(e, 'Delete failed'))).finally(() => setBusy(false));
  };
  const names = r.bills.slice(0, 6).map((b) => b.doc_no).join(', ');
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-rose-200 bg-white px-4 py-3" data-testid="ewb-tally-waiting">
      <Trash2 className="w-5 h-5 text-rose-600" />
      <div className="text-sm">
        <div className="font-semibold"><span data-testid="ewb-tally-waiting-count">{r.count}</span> bill(s) still waiting for Tally</div>
        <div className="text-xs text-gray-600">Sent to the Tally queue but never got an EWB No: {names}{r.count > 6 ? ' …' : ''}. Bills that already have an EWB No are not touched.</div>
      </div>
      <div className="ml-auto flex gap-2">
        {sure && <Button size="sm" variant="ghost" onClick={() => setSure(false)} data-testid="ewb-tally-waiting-cancel">Keep them</Button>}
        <Button size="sm" variant={sure ? 'destructive' : 'outline'} className={sure ? '' : 'text-rose-700'} onClick={() => (sure ? del() : setSure(true))} disabled={busy}
          data-testid="ewb-tally-waiting-delete">
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Trash2 className="w-4 h-4 mr-1" />}{sure ? `Yes, delete ${r.count}` : 'Delete them'}</Button>
      </div>
    </div>
  );
};

export default TallyWaitingCard;
